import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { payrollApi } from "../../lib/api";

export default function PeriodAuditModal({ periodId, onClose }) {
  const [entries, setEntries] = useState(null);
  useEffect(() => {
    if (!periodId) { setEntries([]); return; }
    payrollApi.listPeriodAudit(periodId).then(setEntries).catch(() => setEntries([]));
  }, [periodId]);

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-6" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-y-auto border border-slate-200" data-testid="period-audit-modal">
        <div className="px-5 py-3.5 border-b border-slate-100 flex items-center justify-between sticky top-0 bg-white">
          <div className="text-[14px] font-semibold text-slate-900">Payroll Period Audit History</div>
          <button onClick={onClose} data-testid="period-audit-close" className="h-7 w-7 rounded hover:bg-slate-100 flex items-center justify-center"><X className="h-4 w-4 text-slate-500" /></button>
        </div>
        <div className="p-5 space-y-2">
          {entries === null ? (
            <div className="text-center text-slate-400 italic py-8">Loading…</div>
          ) : entries.length === 0 ? (
            <div className="text-center text-slate-400 italic py-8">No history yet for this period.</div>
          ) : entries.map((e) => (
            <div key={e.id} className="rounded-lg border border-slate-200 p-3 text-[12.5px]" data-testid={`period-audit-entry-${e.id}`}>
              <div className="flex items-center justify-between text-slate-500 text-[11px]">
                <span>{new Date(e.performedAt).toLocaleString()}</span>
                <span className="font-semibold text-slate-700">{e.performedBy}</span>
              </div>
              <div className="mt-1 font-semibold text-slate-800">{e.action}</div>
              {e.detail && <div className="text-slate-600 mt-0.5">{e.detail}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
